import { render, staticRenderFns } from "./film.vue?vue&type=template&id=8572093a&scoped=true&"
import script from "./film.vue?vue&type=script&lang=js&"
export * from "./film.vue?vue&type=script&lang=js&"
import style0 from "./film.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./film.vue?vue&type=style&index=1&id=8572093a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8572093a",
  null
  
)

export default component.exports